var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import styles from '@cof/fs-helper-text-core/lib/helper-text.lit.min.js';
import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * `FsHelperText` implements the Financial Services implementation of the HelperText
 * component.
 * Be sure to consult with the design guidelines for the HelperText component to ensure proper state
 * usage, it is possible to force the HelperText component into an unsupported state.
 *
 * ## Installation
 * ### Install the node module:
 * ```bash
 * npm i @cof/fs-helper-text-wc
 * ```
 *
 * ## Usage
 * To import the side-effectful registration of `<fs-helper-text>` call
 *
 * ```javascript
 * import '@cof/fs-helper-text-wc/fs-helper-text.js';
 * ```
 *
 * To import the `FsHelperText` class as either a base class or to self-register the custom element, use
 *
 * ```javascript
 * import { FsHelperText } from '@cof/fs-helper-text-wc';
 * ```
 *
 * ## Anatomy
 * ### DOM Structure
 * ```html
 *   <fs-helper-text type="primary" error="Will show if present" helper="Helper text" id="helper"></fs-helper-text>
 * ```
 *
 * @element fs-helper-text
 * @slot - The default slot can be used for adding additional rich content to the helper text component. Any anchor tags will be styled automatically
 */
export class FsHelperText extends LitElement {
    constructor() {
        super(...arguments);
        /** The error message to display */
        this.error = '';
        /** The helper text to display */
        this.helper = '';
        /** The helper text type */
        this.type = 'default';
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static get styles() {
        return [styles, css `:host { display: block; }`];
    }
    get helperText() {
        return this.error ? this.error : this.helper || '';
    }
    render() {
        return html `<span class="fs-helper-text fs-helper-text--${this.error ? 'error' : this.type} " part="fs-helper-text">
      <slot>${this.helperText}</slot>
    </span>`;
    }
}
/** The element's canonical name for use with safe define */
FsHelperText.canonicalName = 'helper-text';
__decorate([
    property({ type: String, reflect: true })
], FsHelperText.prototype, "error", void 0);
__decorate([
    property({ type: String, reflect: true })
], FsHelperText.prototype, "helper", void 0);
__decorate([
    property({ type: String, reflect: true })
], FsHelperText.prototype, "type", void 0);
//# sourceMappingURL=HelperText.js.map